import type { Observable } from "rxjs";
import { map } from "rxjs/operators";

import type { ILogin, IResponse, IToken, TwoFactorAuthMode } from "App/Modules/Models";

import type { IAccountRepository, ILoginService, ITokenService } from "App/Modules/Auth";

import "../../Repositories/Account/AccountRepository";

export class LoginService implements ILoginService {
    public static $inject: string[] = ["mmTokenService", "mmAccountRepository", "irLanguageCacheService"];

    constructor(
        private readonly tokenService: ITokenService,
        private readonly accountRepository: IAccountRepository,
        private readonly languageCacheService: { clearCache: () => void },
    ) {}

    public isLoggedInObservable(): Observable<boolean> {
        return this.tokenService.tokenObservable().pipe(map((t) => t !== null));
    }

    public getTwoFactorMode(username: string): Observable<IResponse<TwoFactorAuthMode>> {
        return this.accountRepository.getTwoFactorAuthMode(username);
    }

    public login(login: ILogin): Observable<IResponse<IToken>> {
        return this.tokenService.login(login);
    }

    public logout(): void {
        this.languageCacheService.clearCache();
        this.tokenService.logout();
    }
}
